import { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import config from '~/Config';

export const usePaddleCheckout = ({ onEvent, settings = {} }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [completedPurchase, setCompletedPurchase] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const user = useSelector(({ User }) => User.data);

  const handlePaddleEvent = useCallback(
    event => {
      console.log('PaddleCheckout', 'event', event.name, event.data);

      if (event.name === 'checkout.loaded') {
        setIsLoading(false);
      }

      if (event.name === 'checkout.completed') {
        setCompletedPurchase(true);
      }

      onEvent?.(event);
    },
    [onEvent]
  );

  const initializePaddle = useCallback(() => {
    if (!window.Paddle) {
      console.error('Paddle is not defined');
      return false;
    }

    const paddleOpts = {
      token: config.paddleKey,
      checkout: {
        settings: {
          displayMode: 'overlay',
          ...settings,
        },
      },
      eventCallback: handlePaddleEvent,
    };

    if (user.paddle_id) {
      paddleOpts.pwCustomer = {
        id: user.paddle_id,
      };
    }
    console.log('PaddleCheckout', 'initializePaddle', paddleOpts);

    if (!window.Paddle.Initialized) {
      window.Paddle.Environment.set(config.paddleEnvironment);
      window.Paddle.Initialize(paddleOpts);
    } else {
      window.Paddle.Update(paddleOpts);
    }

    setIsInitialized(true);
    return true;
  }, [settings, handlePaddleEvent, isInitialized, user.paddle_id]);

  const openCheckout = useCallback(
    settings => {
      if (!isInitialized) {
        initializePaddle();
      }

      setIsLoading(true);
      setCompletedPurchase(false);

      window.Paddle.Checkout.open(settings);
    },
    [initializePaddle]
  );

  const closeCheckout = useCallback(() => {
    if (!window.Paddle) return;
    window.Paddle.Checkout.close();
  }, []);

  return {
    isLoading,
    completedPurchase,
    openCheckout,
    closeCheckout,
    initializePaddle,
  };
};

export default usePaddleCheckout;
